import { render, staticRenderFns } from "./Func20Declaracoes.vue?vue&type=template&id=c0b25fa8"
import script from "./Func20Declaracoes.vue?vue&type=script&lang=js"
export * from "./Func20Declaracoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports